"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICancelBookingComponent = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var main_1 = require("../../../../../reducers/slices/main");
var react_redux_1 = require("react-redux");
var cancel_booking_1 = require("../../../../../api/calls/clinic_booking/cancel_booking");
var react_router_dom_1 = require("react-router-dom");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var ICancelBookingComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var booking = props.booking;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _o = (0, react_1.useState)(false), isLoadindData = _o[0], setIsLoadindData = _o[1];
    var cancelBooking = function (booking) {
        setIsLoadindData(true);
        (0, cancel_booking_1.cancel_booking)({
            urn_id: booking.urn_id,
        }).then(function (response) {
            if (response.success) {
                setIsLoadindData(false);
                navigate("/clinic/booking/history");
                dispatch((0, main_1.setContentModal)({
                    title: "Success!",
                    content: react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: response === null || response === void 0 ? void 0 : response.message }),
                }));
            }
            else {
                setIsLoadindData(false);
                dispatch((0, main_1.setContentModal)({
                    title: "Error",
                    content: react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: response === null || response === void 0 ? void 0 : response.message }),
                }));
            }
        });
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-4" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Are you sure you want to cancel the following booking? " }),
        react_1.default.createElement("div", { className: "flex flex-col gap-2 w-full" },
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faHospital }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_a = booking === null || booking === void 0 ? void 0 : booking.clinic.clinic_name) !== null && _a !== void 0 ? _a : "", textColor: "text-primary", bold: true, size: "small" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faLocation }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat((_d = (_c = (_b = booking === null || booking === void 0 ? void 0 : booking.clinic) === null || _b === void 0 ? void 0 : _b.address) === null || _c === void 0 ? void 0 : _c.line_one) !== null && _d !== void 0 ? _d : "", " ").concat((_g = (_f = (_e = booking === null || booking === void 0 ? void 0 : booking.clinic) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.line_two) !== null && _g !== void 0 ? _g : ""), textColor: "text-black", size: "small" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faUser }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat((_j = (_h = booking === null || booking === void 0 ? void 0 : booking.patient) === null || _h === void 0 ? void 0 : _h.name) !== null && _j !== void 0 ? _j : "", " ").concat((_l = (_k = booking === null || booking === void 0 ? void 0 : booking.patient) === null || _k === void 0 ? void 0 : _k.surname) !== null && _l !== void 0 ? _l : ""), textColor: "text-success", bold: true, size: "small" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faNotes }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: (_m = booking === null || booking === void 0 ? void 0 : booking.reason) !== null && _m !== void 0 ? _m : "", textColor: "text-black", size: "small" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCalendar }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat((0, moment_timezone_1.default)(booking.slot.start_time).tz("Africa/Johannesburg").format("dddd, MMMM Do YYYY")), textColor: "text-black", size: "small" })),
            react_1.default.createElement("div", { className: "flex flex-row gap-2 items-center" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faClock }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat((0, moment_timezone_1.default)(booking.slot.start_time).tz("Africa/Johannesburg").format("h:mm A"), " - ").concat((0, moment_timezone_1.default)(booking.slot.end_time)
                        .tz("Africa/Johannesburg")
                        .format("h:mm A")), textColor: "text-black", size: "small" }))),
        react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-center" },
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Cancel", backgroundColor: "bg-primary", size: "xsmall", onClick: function () {
                    dispatch((0, main_1.setContentModal)(null));
                } }),
            react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Confirm", backgroundColor: "bg-success", loading: isLoadindData, size: "xsmall", onClick: function () {
                    cancelBooking(booking);
                } }))));
};
exports.ICancelBookingComponent = ICancelBookingComponent;
